import { render } from "./BlockControls.vue?vue&type=template&id=0cdc8c33"
import script from "./BlockControls.vue?vue&type=script&lang=js"
export * from "./BlockControls.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__